import { render } from "./reversedRating.vue?vue&type=template&id=982d749e"
import script from "./reversedRating.vue?vue&type=script&lang=js"
export * from "./reversedRating.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__